import { Component, Input } from '@angular/core';
import { HomeTxtsKey } from 'src/app/components/pages/home/h-interfaces/txt-h-keys/home-txt-key.interface';

@Component({
  selector: 'app-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss']
})
export class OfferCardComponent {
  @Input() imgMosaico?: string;
  @Input() texts?: HomeTxtsKey;

  get subtitleParts(): [string, string] {
    const parts = this.texts?.cards_section?.subtitle?.split('\n') ?? ['', ''];
    return [parts[0] ?? '', parts[1] ?? ''];
  }

  get descriptionParts(): [string, string] {
    const parts = this.texts?.cards_section?.description?.split('|') ?? ['', ''];
    return [parts[0] ?? '', parts[1] ?? ''];
  }
}
